import { Store } from 'src/store/index';

const getInternalUid = (store: Store) => store.design.internalUid;

export default getInternalUid;
